var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTariffs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.143 4.286a2.57 2.57 0 0 0-2.572-2.572H9.43a2.57 2.57 0 0 0-2.572 2.572v15.428a2.57 2.57 0 0 0 2.572 2.572h5.143a2.57 2.57 0 0 0 2.57-2.572zm-7.714-.857h5.143c.473 0 .857.383.857.857v15.428a.857.857 0 0 1-.857.857H9.429a.857.857 0 0 1-.858-.857V4.286c0-.474.384-.857.858-.857M4.286 5.143a.857.857 0 1 1 0 1.714h-.857a.857.857 0 0 0-.858.857v8.572c0 .473.384.857.858.857h.857a.857.857 0 1 1 0 1.714h-.857a2.57 2.57 0 0 1-2.572-2.571V7.714A2.57 2.57 0 0 1 3.43 5.143zm18.857 2.571a2.57 2.57 0 0 0-2.572-2.571h-.857a.857.857 0 1 0 0 1.714h.858c.473 0 .857.384.857.857v8.572a.857.857 0 0 1-.857.857h-.858a.857.857 0 1 0 0 1.714h.858a2.57 2.57 0 0 0 2.57-2.571z",
  clipRule: "evenodd"
})));
export default SvgTariffs;